(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nw-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Shopify 把各分区的 section JS 打包成一个文件，执行时机不保证 DOM 已就绪，
  // 所以统一等 DOMContentLoaded 再跑；已就绪则立即跑。
  function boot() {

  var root = document.querySelector("[data-nw-buybox]");
  if (!root) return;

  var sid = root.getAttribute("data-section-id");
  var jsonEl = document.getElementById("VariantsJson-" + sid);
  var master = document.getElementById("ProductSelect-" + sid);
  var form = document.getElementById("AddToCartForm-" + sid);
  var cta = document.getElementById("AddToCart-" + sid);
  var ctaText = root.querySelector("[data-nw-cta-text]");
  var priceEl = root.querySelector("[data-nw-price]");
  var compareEl = root.querySelector("[data-nw-compare]");
  var saveEl = root.querySelector("[data-nw-save]");
  var msg = root.querySelector("[data-nw-msg]");
  var selects = root.querySelectorAll("[data-nw-option]");

  var variants = [];
  try { variants = JSON.parse(jsonEl.value); } catch (e) { return; }

  function money(cents) {
    var s = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return "$" + s;
  }

  function chosen() {
    return Array.prototype.map.call(selects, function (s) { return s.value; });
  }

  function match() {
    var want = chosen();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < want.length; j++) {
        if (v.options[j] !== want[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function render() {
    var v = match();
    if (!v) {
      if (cta) { cta.disabled = true; }
      if (ctaText) { ctaText.textContent = "Unavailable"; }
      return;
    }
    if (master) master.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) {
      var has = v.compare_at_price && v.compare_at_price > v.price;
      compareEl.hidden = !has;
      if (has) compareEl.textContent = money(v.compare_at_price);
    }
    if (saveEl) {
      var has2 = v.compare_at_price && v.compare_at_price > v.price;
      saveEl.hidden = !has2;
      if (has2) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        saveEl.textContent = "Save " + pct + "% - Limited Time Only";
      }
    }
    if (cta) cta.disabled = !v.available;
    if (ctaText) ctaText.textContent = v.available ? "Add to Cart" : "Sold Out";
    if (msg) { msg.textContent = ""; msg.removeAttribute("data-state"); }
    // 让主题里监听 variantChange 的组件（如动态结账）也能跟上
    document.dispatchEvent(new CustomEvent("variantChange", { detail: { variant: v } }));
  }

  Array.prototype.forEach.call(selects, function (s) {
    s.addEventListener("change", render);
  });

  // 数量加减
  root.querySelectorAll("[data-nw-qty]").forEach(function (b) {
    b.addEventListener("click", function () {
      var input = root.querySelector(".nw-bb__qinput");
      if (!input) return;
      var n = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, n + parseInt(b.getAttribute("data-nw-qty"), 10));
    });
  });

  // 缩略图左右箭头
  root.querySelectorAll("[data-nw-arrow]").forEach(function (b) {
    b.addEventListener("click", function () {
      var strip = root.querySelector(".nw-bb__thumbs");
      if (strip) strip.scrollLeft += parseInt(b.getAttribute("data-nw-arrow"), 10) * 200;
    });
  });

  // 画廊
  root.querySelectorAll("[data-nw-thumb]").forEach(function (b) {
    b.addEventListener("click", function () {
      var i = b.getAttribute("data-nw-thumb");
      root.querySelectorAll("[data-nw-slide]").forEach(function (img) {
        img.classList.toggle("is-active", img.getAttribute("data-nw-slide") === i);
      });
      root.querySelectorAll("[data-nw-thumb]").forEach(function (t) {
        var on = t === b;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
    });
  });

  // 加购交给主题自己的 AjaxProduct —— 购物车抽屉、cart:build 全都照旧
  if (form && window.theme && theme.AjaxProduct) {
    new theme.AjaxProduct(form);
    form.addEventListener("submit", function () {
      if (cta) cta.classList.add("is-loading");
      if (msg) { msg.textContent = ""; msg.removeAttribute("data-state"); }
    });
    document.addEventListener("ajaxProduct:added", function () {
      if (cta) cta.classList.remove("is-loading");
      if (msg) { msg.textContent = "Added to your cart."; msg.setAttribute("data-state", "success"); }
    });
    document.addEventListener("ajaxProduct:error", function (e) {
      if (cta) cta.classList.remove("is-loading");
      if (msg) {
        msg.textContent = (e.detail && e.detail.errorMessage) || "Could not add to cart.";
        msg.setAttribute("data-state", "error");
      }
    });
  }

  render();

  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-carousel"] && !Shopify.designMode) return;
  try {
    
/* 轮播：箭头、点两侧、鼠标拖、当前张（透明度 / 进度条 / 模式名与渐变）、到头禁用。
   轨道本身是原生 scroll-snap。分区脚本执行时机不保证 DOM 就绪（坑 #9），先判 readyState。
   注意：本注释里不能出现 Liquid 标签的字面写法，分词器会误判（坑 7d）。 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    document.querySelectorAll('.nw-cr').forEach(function (root) {
      var track = root.querySelector('.nw-cr__track');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.nw-cr__slide'));
      if (!track || !slides.length) return;

      var strip = root.classList.contains('nw-cr--strip');
      /* 手机端（和 CSS 同一个断点）strip 也是当前张居中，初始张可以单独设 */
      var mq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
      function mobile() { return !!(mq && mq.matches); }
      function leftAligned() { return strip && !mobile(); }
      var prev = root.querySelector('.nw-cr__btn--prev');
      var next = root.querySelector('.nw-cr__btn--next');
      var label = root.querySelector('.nw-cr__label');
      var dots = Array.prototype.slice.call(root.querySelectorAll('.nw-cr__dot'));
      var descs = Array.prototype.slice.call(root.querySelectorAll('.nw-cr__desc'));
      var current = -1;
      var ticking = false;

      /* 对齐线（strip 的内容列左缘）。scroll-padding 写的是 max(百分比, 算式)，
         getComputedStyle 读回来是表达式字符串，没法 parseFloat（早先读百分比也踩过，坑 #46）。
         按构造：左侧留边 + 间距 = 对齐线，所以滚动到 0 时第一张的左缘就是对齐线 —— 直接量它 */
      function padLeft() {
        var t = track.getBoundingClientRect();
        return slides[0].getBoundingClientRect().left - t.left + track.scrollLeft;
      }
      function maxScroll() { return track.scrollWidth - track.clientWidth; }

      /* 某一张到位时轨道应有的 scrollLeft。两边都用 getBoundingClientRect 量（视口坐标，
         不受 offsetParent 影响）。spotlight 对中，strip 对齐内容列左缘。 */
      function targetFor(i) {
        var t = track.getBoundingClientRect();
        var r = slides[i].getBoundingClientRect();
        var x = leftAligned()
          ? track.scrollLeft + (r.left - t.left - padLeft())
          : track.scrollLeft + (r.left + r.width / 2) - (t.left + t.width / 2);
        return Math.max(0, Math.min(maxScroll(), Math.round(x)));
      }

      function nearest() {
        var best = 0, bestD = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(targetFor(i) - track.scrollLeft);
          if (d < bestD) { bestD = d; best = i; }
        }
        return best;
      }

      function paint(i) {
        if (i === current) return;
        current = i;
        slides.forEach(function (sl, n) { sl.classList.toggle('is-active', n === i); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        descs.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        if (label) {
          var sl = slides[i];
          label.textContent = sl.getAttribute('data-nw-label') || '';
          var g1 = sl.getAttribute('data-nw-g1'), g2 = sl.getAttribute('data-nw-g2');
          if (g1) label.style.setProperty('--nw-cr-g1', g1);
          if (g2) label.style.setProperty('--nw-cr-g2', g2);
        }
      }

      function update() {
        var i = nearest();
        paint(i);
        var max = maxScroll();
        /* 注释说明图：第一张 / 最后一张时对应一侧的按钮变灰 */
        if (prev) prev.disabled = track.scrollLeft <= 1 || i === 0;
        if (next) next.disabled = track.scrollLeft >= max - 1 || i === slides.length - 1;
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }

      /* 平滑滚动期间 scroll 事件节奏各浏览器不一，页面被遮挡时甚至不派发（坑 35），
         滚完补量两次，当前张 / 按钮状态不掉队 */
      function go(i, instant) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        /* 初始定位 / 窗口缩放要瞬间到位：'auto' 的意思是跟随 CSS 的 scroll-behavior（这里是 smooth），不是瞬间 */
        track.scrollTo({ left: targetFor(i), behavior: instant ? 'instant' : 'smooth' });
        if (instant) { update(); return; }
        setTimeout(update, 320);
        setTimeout(update, 700);
      }

      if (prev) prev.addEventListener('click', function () { go(nearest() - 1); });
      if (next) next.addEventListener('click', function () { go(nearest() + 1); });

      /* spotlight：点露边的那张就切过去 */
      var dragged = false;
      slides.forEach(function (sl, n) {
        sl.addEventListener('click', function (e) {
          if (dragged) { e.preventDefault(); e.stopPropagation(); return; }
          if (!strip && n !== current) go(n);
        });
      });

      /* 鼠标拖动（触屏本来就能滑，只接管鼠标） */
      var startX = 0, startLeft = 0, down = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; dragged = false;
        startX = e.clientX; startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!dragged && Math.abs(dx) > 5) {
          dragged = true;
          track.classList.add('is-dragging');
        }
        if (dragged) track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (dragged) {
          track.classList.remove('is-dragging');
          go(nearest());
          setTimeout(function () { dragged = false; }, 0);
        }
      });

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { go(current < 0 ? 0 : current, true); });

      var start = parseInt(root.getAttribute(mobile() ? 'data-start-m' : 'data-start'), 10) ||
                  parseInt(root.getAttribute('data-start'), 10) || 1;
      go(start - 1, true);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-layers"] && !Shopify.designMode) return;
  try {
    
/* 字母圆点的点击交互。
   行为对齐主题 left-under-the-covers（参考页 mh2-7-zone-hybrid-mattress 的 Layers of Quality）：
   单选；再点一次同一个 = 取消。区别是我们**不隐藏**其余文字块，
   只把它们淡下去 —— 墨刀是五块全显示，隐藏就不是 1:1 了。

   ⚠️ 分区的 javascript 块被打包，执行时机不保证 DOM 就绪（坑 #9），
      所以要判 readyState，不能只挂 DOMContentLoaded。
      （注意：这段注释里不能出现 Liquid 标签的字面写法，分词器会误判。）*/
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.querySelectorAll('.nw-ly').forEach(function (root) {
      var marks = root.querySelectorAll('.nw-ly__mark');
      if (!marks.length) return;

      function setActive(item) {
        var id = item ? item.getAttribute('data-nw-layer') : null;

        root.querySelectorAll('.nw-ly__item').forEach(function (it) {
          var on = it === item;
          it.classList.toggle('is-active', on);
          var btn = it.querySelector('.nw-ly__mark');
          if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        /* 图上对应位置的热点跟着闪 —— 图里的 a~e 是画死的，
           所以叠了透明热点，让它替字母发光。 */
        root.querySelectorAll('.nw-ly__hot').forEach(function (h) {
          h.classList.toggle('is-active', !!id && h.getAttribute('data-nw-hot') === id);
        });

        root.classList.toggle('is-picking', !!item);
      }

      function toggle(item) {
        if (!item) return;
        setActive(item.classList.contains('is-active') ? null : item);
      }

      marks.forEach(function (btn) {
        btn.addEventListener('click', function () {
          toggle(btn.closest('.nw-ly__item'));
        });
      });

      /* 点图上的字母也能选中对应文字块 */
      root.querySelectorAll('.nw-ly__hot').forEach(function (h) {
        h.addEventListener('click', function () {
          var id = h.getAttribute('data-nw-hot');
          toggle(root.querySelector('.nw-ly__item[data-nw-layer="' + id + '"]'));
        });
      });

      /* 可选：滚动到视口后自动点开第一块（参考页就是这么做的）。
         默认关闭 —— 开了的话页面静止时就有 4 块是淡的，和墨刀不一致。 */
      if (root.dataset.autoOpenFirst === 'true' && 'IntersectionObserver' in window) {
        var first = root.querySelector('.nw-ly__item');
        if (first) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              io.disconnect();
              setTimeout(function () { setActive(first); }, 600);
            });
          }, { threshold: 0.35 });
          io.observe(root);
        }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
